import React from 'react'

import {IconButton, Popover, ListItem} from '../index.js'
import {Toggle, Select, FormStack} from '../forms/index.js'
import {SelectChangeEvent} from '../forms/Select.js'
import t from '../../../helpers/Languages.js'
import {InternalColumn} from './types.js'
import {getMenuStyle, menuAnchorStyle, tableMenus, tablePagination} from './styles.js'

interface TableSettingsProps {
    columns: InternalColumn[]
    noPagination?: boolean
    pageSize: number
    onChangePageSize: (event: SelectChangeEvent) => void
    onToggleColumn: (id: string) => void
    hasSettings: boolean
    onReset: () => void
    maxHeight: number
}

/** The settings menu at the right of the header: page size, visible columns and reset */
const TableSettings = ({columns, noPagination, pageSize, onChangePageSize, onToggleColumn, hasSettings, onReset, maxHeight}: TableSettingsProps) => {
    // The Popover is placed on the button itself, so it is the anchor (a wrapper around an absolute button has no size)
    return (
        <div style={menuAnchorStyle}>
            <Popover
                style={{position: 'absolute', top: tableMenus.buttonTop, right: 0}}
                noClose={true}
                placement='left'
                content={
                    <div style={{...getMenuStyle(tableMenus.settingsWidth, maxHeight), padding: tableMenus.settingsPadding}}>
                        <FormStack>
                            {!noPagination && (
                                <Select label={t('tableRowsPerPage')} value={pageSize} onChange={onChangePageSize}>
                                    {tablePagination.pageSizeOptions.map((size) => (
                                        <option key={size} value={size}>{size}</option>
                                    ))}
                                </Select>
                            )}

                            <FormStack gap={0}>
                                {columns.filter((column) => column.title && !column.filterOnly).map((column) => (
                                    <Toggle
                                        key={column.id}
                                        label={column.title}
                                        checked={column.visible}
                                        onChange={() => onToggleColumn(column.id)}
                                    />
                                ))}

                                {hasSettings &&
                                    <ListItem onClick={onReset}>
                                        {t('resetTable')}
                                    </ListItem>
                                }
                            </FormStack>
                        </FormStack>
                    </div>
                }
            >
                <IconButton aria-label={t('tableSettings')} aria-haspopup='dialog'>
                    <i className='mdi mdi-dots-vertical' />
                </IconButton>
            </Popover>
        </div>
    )
}

export default TableSettings
